import React, { useState } from 'react';
import { api } from '../../api/client';
import { useToast } from '../../utils/ToastContext';
import PhoneInput from '../../components/PhoneInput';
import worldCountries from '../../data/worldCountries';

const BUSINESS_TYPES = [
  'شركة شحن', 'شركة توصيل', 'متجر إلكتروني', 'مؤسسة لوجستية',
  'مطعم / مقهى', 'صيدلية', 'مكتب استيراد وتصدير', 'أخرى'
];

export default function LandingPage() {
  const { addToast } = useToast();
  const [form, setForm] = useState({
    name: '', email: '', phone: '', country: '', business_type: '',
    rider_count: '', description: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  function handleChange(field, value) {
    setForm(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => { const n = { ...prev }; delete n[field]; return n; });
  }

  function validate() {
    const errs = {};
    if (!form.name.trim()) errs.name = 'يرجى إدخال الاسم';
    if (!form.phone.trim() && !form.email.trim()) {
      errs.phone = 'يرجى إدخال رقم الجوال أو البريد الإلكتروني';
    }
    if (form.email.trim() && !/\S+@\S+\.\S+/.test(form.email)) errs.email = 'بريد إلكتروني غير صالح';
    if (!form.country.trim()) errs.country = 'يرجى اختيار الدولة';
    if (!form.business_type.trim()) errs.business_type = 'يرجى إدخال نوع النشاط';
    if (!form.rider_count || parseInt(form.rider_count) < 1) errs.rider_count = 'يرجى إدخال عدد المناديب';
    return errs;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;
    setSubmitting(true);
    try {
      await api.submitDemoRequest({ ...form, rider_count: parseInt(form.rider_count) });
      setSubmitted(true);
      addToast('تم استلام طلبك بنجاح! سنتواصل معك قريباً', 'success');
    } catch (err) {
      addToast(err.message, 'error');
    } finally {
      setSubmitting(false);
    }
  }

  if (submitted) {
    return (
      <div style={styles.wrapper}>
        <div style={styles.successWrap}>
          <div style={styles.successCard}>
            <div style={styles.successCheck}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <h2 style={styles.successTitle}>تم استلام طلبك بنجاح!</h2>
            <p style={styles.successText}>شكراً لاهتمامك. فريق فكر نوفا سيتواصل معك خلال ٢٤ ساعة لمناقشة احتياجاتك وترتيب تجربة مجانية كاملة للنظام.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.wrapper}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800&display=swap');
        *{font-family:'Tajawal',system-ui,sans-serif}
        @keyframes spin{to{transform:rotate(360deg)}}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        @keyframes waIn{from{opacity:0;transform:scale(0.5) translateY(20px)}to{opacity:1;transform:scale(1) translateY(0)}}
        @media(max-width:900px){
          .lp-form-split{grid-template-columns:1fr!important}
          .lp-hero-title{font-size:34px!important}
          .lp-section-title{font-size:26px!important}
          .lp-hero-br{display:none!important}
        }
        @media(max-width:640px){
          .lp-features-grid{grid-template-columns:1fr!important}
          .lp-why-grid{grid-template-columns:1fr!important}
          .lp-steps-grid{grid-template-columns:1fr!important}
          .lp-nav-links{display:none!important}
          .lp-mobile-toggle{display:block!important}
          .lp-mobile-cta{display:inline-flex!important}
          .lp-hero-title{font-size:28px!important}
          .lp-stat-dot{display:none!important}
          .lp-stat-item{flex:0 0 45%!important}
          .lp-footer-grid{grid-template-columns:1fr!important}
          .lp-form-row{grid-template-columns:1fr!important}
          .lp-step-arrow{display:none!important}
          .lp-hero-badge{font-size:11px!important}
          .lp-mobile-cta{display:inline-flex!important}
        }
      `}</style>

      {/* ── NAV ── */}
      <nav style={styles.nav}>
        <div style={styles.navInner}>
          <div style={styles.logo}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#E0A526" strokeWidth="2" strokeLinecap="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
            <span style={styles.logoText}>فكر نوفا</span>
            <span style={styles.logoBadge}>للشحن</span>
          </div>
          <div className="lp-nav-links" style={styles.navLinks}>
            <a href="#features" style={styles.navLink}>المميزات</a>
            <a href="#why-us" style={styles.navLink}>لماذا فكر نوفا</a>
            <a href="#faq" style={styles.navLink}>الأسئلة</a>
            <a href="#demo" style={styles.navCtaBtn}>اطلب تجربة مجانية</a>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <a href="#demo" className="lp-mobile-cta" style={styles.mobileCtaBtn}>اطلب تجربة مجانية</a>
            <button className="lp-mobile-toggle" style={styles.mobileToggle} onClick={() => {
              const el = document.getElementById('lp-mobile-nav');
              if (el) el.style.display = el.style.display === 'flex' ? 'none' : 'flex';
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3E2C6E" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            </button>
          </div>
        </div>
        <div id="lp-mobile-nav" style={styles.mobileNav}>
          <a href="#features" style={styles.mobileNavLink}>المميزات</a>
          <a href="#why-us" style={styles.mobileNavLink}>لماذا فكر نوفا</a>
          <a href="#faq" style={styles.mobileNavLink}>الأسئلة</a>
          <a href="#demo" style={styles.mobileNavLink}>اطلب تجربة مجانية</a>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section style={styles.hero}>
        <div style={styles.heroBg} />
        <div style={styles.heroBgGlow} />
        <div style={styles.heroInner}>
          <div className="lp-hero-badge" style={styles.heroBadge}>نظام متكامل لشركات الشحن والتوصيل</div>
          <h1 className="lp-hero-title" style={styles.heroTitle}>
            منصة <span style={styles.heroAccent}>فكر نوفا</span><br className="lp-hero-br" />
            لإدارة عمليات الشحن والتوصيل
          </h1>
          <p style={styles.heroDesc}>
            أنت تتولى إدارة العمل اللوجستي، ونحن نتولى الجانب التقني. نظام سحابي متعدد العملاء يدعم شركات الشحن والتوصيل في <strong>السعودية، الإمارات، العراق، سوريا، لبنان، ليبيا</strong> وأكثر من ١٢ دولة عربية.
          </p>
          <div style={styles.heroCta}>
            <a href="#demo" style={styles.btnPrimary}>
              ابدأ تجربة مجانية
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{ marginRight: 8 }}><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </a>
            <a href="#features" style={styles.btnOutline}>استكشف المميزات</a>
          </div>
        </div>
      </section>

      {/* ── STATISTICS ── */}
      <section style={styles.statsBar}>
        <div style={styles.statsInner}>
          <div className="lp-stat-item" style={styles.statItem}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#E0A526" strokeWidth="1.5" style={{ margin: '0 auto 8px', display: 'block' }}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            <span style={styles.statNum}>+٥٠</span>
            <span style={styles.statLabel}>شركة شحن</span>
          </div>
          <div className="lp-stat-dot" style={styles.statDot} />
          <div className="lp-stat-item" style={styles.statItem}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#E0A526" strokeWidth="1.5" style={{ margin: '0 auto 8px', display: 'block' }}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            <span style={styles.statNum}>+١٠٠٠٠</span>
            <span style={styles.statLabel}>شحنة شهرياً</span>
          </div>
          <div className="lp-stat-dot" style={styles.statDot} />
          <div className="lp-stat-item" style={styles.statItem}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#E0A526" strokeWidth="1.5" style={{ margin: '0 auto 8px', display: 'block' }}><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
            <span style={styles.statNum}>+١٢</span>
            <span style={styles.statLabel}>دولة عربية</span>
          </div>
          <div className="lp-stat-dot" style={styles.statDot} />
          <div className="lp-stat-item" style={styles.statItem}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#E0A526" strokeWidth="1.5" style={{ margin: '0 auto 8px', display: 'block' }}><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            <span style={styles.statNum}>دعم فني</span>
            <span style={styles.statLabel}>على مدار الساعة</span>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section id="features" style={styles.section}>
        <div style={styles.sectionInner}>
          <div style={styles.sectionHeader}>
            <span style={styles.sectionTag}>مميزات المنصة</span>
            <h2 className="lp-section-title" style={styles.sectionTitle}>كل ما تحتاجه لإدارة عمليات الشحن في مكان واحد</h2>
            <p style={styles.sectionSub}>صممنا فكر نوفا لتكون الحل الأمثل لشركات الشحن والتوصيل على اختلاف أحجامها</p>
            <p style={{ ...styles.sectionSub, fontSize: 14, marginTop: 0, color: '#6B6380' }}>مع إمكانية تفعيل خاصية <strong style={{ color: '#E0A526' }}>القيادة الذكية</strong> المدعومة بالذكاء الاصطناعي لإدارة الشركة بشكل آلي وذكي</p>
          </div>
          <div className="lp-features-grid" style={styles.featuresGrid}>
            {[
              { icon: <><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></>, title: 'إدارة الطلبيات', desc: 'إنشاء وتتبع الطلبيات بشكل فردي أو جماعي. إرفاق باركود وملصقات شحن احترافية مع أرشفة ذكية للطلبيات القديمة.' },
              { icon: <><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></>, title: 'تتبع لحظي', desc: 'رابط تتبع عام لكل شحنة مع كود QR مطبوع. العميل يتابع شحنته بنفسه دون الحاجة للتواصل معك.' },
              { icon: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>, title: 'نظام المناديب', desc: 'إدارة فريق المناديب مع تحديد الحمولة القصوى، تعيين الطلبيات، وتحديث حالة التوصيل مباشرة من تطبيق المندوب.' },
              { icon: <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>, title: 'بوابات دخول منفصلة', desc: 'لكل صلاحية واجهتها: لوحة تحكم للشركة، بوابة خاصة للتجار، وتطبيق مندوب سهل الاستخدام.' },
              { icon: <><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>, title: 'تقارير وإحصائيات', desc: 'رسوم بيانية تفاعلية، مؤشرات أداء، تصدير تقارير CSV، وتحليل دوري يساعدك في اتخاذ قرارات أفضل.' },
              { icon: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>, title: 'أمان وخصوصية', desc: 'بياناتك مشفرة ومحمية. نظام صلاحيات متعدد المستويات يضمن وصول كل شخص للمعلومات المصرح له فقط.' },
              { icon: <><path d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 7h10l-1 7H8l-1-7z"/><circle cx="12" cy="12" r="10"/></>, title: 'قيادة ذكية بالذكاء الاصطناعي', desc: 'ميزة اختيارية تتيح للذكاء الاصطناعي إدارة شركتك بكفاءة — توزيع الطلبيات، تحديد الأولويات، واتخاذ القرارات المثلى مع بقائك مشرفاً ومتابعاً.' },
              { icon: <><circle cx="12" cy="12" r="10"/><path d="M12 2a10 10 0 0 0-10 10c0 4.42 2.9 8.17 6.86 9.47L12 22l3.14-.53A10.01 10.01 0 0 0 22 12 10 10 0 0 0 12 2z"/><path d="M12 6v6l4 2"/></>, title: 'تحديد المواقع GPS والخرائط الحية', desc: 'تتبع المندوبين على الخريطة بشكل لحظي مع عرض مسار التوصيل. يمكن للتاجر والعميل رؤية موقع المندوب مباشرة ومدة الوصول المقدرة.' },
              { icon: <><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></>, title: 'إدارة أسعار الشحن', desc: 'نظام مرن لتحديد أسعار الشحن بناءً على المسافة، الوزن، الوجهة، وفئة العميل. إمكانية إنشاء عروض أسعار مخصصة لكل تاجر مع تحليل هامش الربح.' },
            ].map((f, i) => (
              <div key={i} style={styles.featureCard}>
                <div style={styles.featureIconWrap}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3E2C6E" strokeWidth="1.5" strokeLinecap="round">{f.icon}</svg>
                </div>
                <h3 style={styles.featureTitle}>{f.title}</h3>
                <p style={styles.featureDesc}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section id="why-us" style={{ ...styles.section, backgroundColor: '#F4F1F8' }}>
        <div style={styles.sectionInner}>
          <div style={styles.sectionHeader}>
            <span style={styles.sectionTag}>لماذا فكر نوفا</span>
            <h2 className="lp-section-title" style={styles.sectionTitle}>شريكك التقني في عالم الشحن</h2>
            <p style={styles.sectionSub}>نحن لا نقدم فقط نظاماً، بل نقدم شراكة تقنية متكاملة لتنمية أعمالك</p>
          </div>
          <div className="lp-why-grid" style={styles.whyGrid}>
            {[
              { icon: <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></>, color: '#3E2C6E', title: 'دعم فني متواصل', desc: 'فريق دعم فني جاهز على مدار الساعة. نوفر لك التدريب اللازم لفريقك ونساعدك في أي استفسار تقني.' },
              { icon: <><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></>, color: '#E0A526', title: 'تطويرات مستمرة', desc: 'نظامنا في تطور دائم. نضيف مميزات جديدة بانتظام بناءً على احتياجات عملائنا وتطورات سوق الشحن.' },
              { icon: <><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></>, color: '#3E2C6E', title: 'تجربة فريدة', desc: 'واجهة عربية كاملة مصممة خصيصاً لسوق الشحن. سهلة الاستخدام، سريعة، وتجربة مستخدم استثنائية.' },
              { icon: <><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>, color: '#E0A526', title: 'قابلية توسع عالية', desc: 'النظام مصمم ليدعم عملك أياً كان حجمه — من شركة ناشئة بعدد محدود من المناديب إلى شركة كبرى تغطي دولاً متعددة.' },
            ].map((w, i) => (
              <div key={i} style={styles.whyCard}>
                <div style={{ ...styles.whyIcon, backgroundColor: w.color + '12', color: w.color }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">{w.icon}</svg>
                </div>
                <h3 style={styles.whyTitle}>{w.title}</h3>
                <p style={styles.whyDesc}>{w.desc}</p>
              </div>
            ))}
          </div>
          <div style={styles.supportBanner}>
            <div style={styles.supportContent}>
              <h3 style={styles.supportTitle}>أنت تتولى إدارة العمل اللوجستي ونحن نتولى الباقي</h3>
              <p style={styles.supportDesc}>
                لا داعي للقلق بشأن الجانب التقني. فريق فكر نوفا يضمن لك نظاماً يعمل بسلاسة، تحديثات مستمرة، ودعماً فنياً على مدار الساعة. ركز على تنمية أعمالك واترك التقنية لنا.
              </p>
            </div>
            <a href="#demo" style={styles.btnPrimary}>اطلب نسخة تجريبية</a>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section style={styles.section}>
        <div style={styles.sectionInner}>
          <div style={styles.sectionHeader}>
            <span style={styles.sectionTag}>خطوات بسيطة</span>
            <h2 className="lp-section-title" style={styles.sectionTitle}>كيف تبدأ مع فكر نوفا؟</h2>
          </div>
          <div className="lp-steps-grid" style={styles.stepsGrid}>
            {[
              { num: '01', title: 'تسجيل الشركة', desc: 'نسجل شركتك في المنصة خلال دقائق ونوفر لك لوحة تحكم خاصة مع رابط دخول مخصص.' },
              { num: '02', title: 'إضافة المناديب والتجار', desc: 'أضف فريقك بسهولة — كل مندوب وتاجر له بوابة دخول مستقلة تتناسب مع مهامه.' },
              { num: '03', title: 'بدء استقبال الطلبيات', desc: 'استقبل طلبيات الشحن من التجار، خصصها للمناديب، وتابع حالة التوصيل لحظياً.' },
              { num: '04', title: 'تحليل وتطوير', desc: 'راجع التقارير والإحصائيات لتحسين أداء فريقك وزيادة كفاءة العمليات.' },
            ].map((s, i) => (
              <div key={i} style={styles.stepCard}>
                <div style={styles.stepNum}>{s.num}</div>
                <h3 style={styles.stepTitle}>{s.title}</h3>
                <p style={styles.stepDesc}>{s.desc}</p>
                {i < 3 && <div className="lp-step-arrow" style={styles.stepArrow}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D4D0E0" strokeWidth="1.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section id="faq" style={{ ...styles.section, backgroundColor: '#F4F1F8' }}>
        <div style={styles.sectionInner}>
          <div style={styles.sectionHeader}>
            <span style={styles.sectionTag}>الأسئلة الشائعة</span>
            <h2 className="lp-section-title" style={styles.sectionTitle}>إجابات عن أسئلتكم</h2>
          </div>
          <div style={styles.faqList}>
            {[
              { q: 'هل المنصة مناسبة لشركتي مهما كان حجمها؟', a: 'نعم، صممنا فكر نوفا ليدعم جميع الأحجام — من المؤسسات الصغيرة التي لديها عدد محدود من المناديب إلى الشركات الكبرى التي تغطي دولاً متعددة.' },
              { q: 'هل يمكنني تجربة المنصة قبل الاشتراك؟', a: 'بالتأكيد. نوفر نسخة تجريبية مجانية كاملة لجميع العملاء. املأ نموذج الطلب وسنتواصل معك لترتيب التجربة.' },
              { q: 'هل تدعمون الدول العربية خارج السعودية؟', a: 'نعم، فكر نوفا تدعم أكثر من ١٢ دولة عربية تشمل الإمارات، العراق، سوريا، لبنان، ليبيا، مصر، الأردن، ودول الخليج.' },
              { q: 'هل يمكن إضافة عدد غير محدود من المناديب والتجار؟', a: 'نعم، بدون أي حدود. يمكنك إضافة عدد غير محدود من المناديب والتجار، وكل منهم له صلاحياته وواجهته المستقلة.' },
              { q: 'كيف يتم دعم العملاء تقنياً؟', a: 'نوفر دعماً فنياً عبر قنوات متعددة. فريق فكر نوفا جاهز لمساعدتك في أي استفسار أو مشكلة تقنية.' },
            ].map((faq, i) => (
              <div key={i} style={styles.faqItem}>
                <button style={styles.faqQuestion} onClick={e => {
                  const p = e.currentTarget.nextElementSibling;
                  const isOpen = p.style.maxHeight && p.style.maxHeight !== '0px';
                  p.style.maxHeight = isOpen ? '0px' : p.scrollHeight + 'px';
                  p.style.borderTopWidth = isOpen ? '0px' : '1px';
                  e.currentTarget.querySelector('svg').style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
                }}>
                  <span>{faq.q}</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3E2C6E" strokeWidth="2" strokeLinecap="round" style={{ transition: 'transform 0.2s', flexShrink: 0 }}><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div style={styles.faqAnswer}>
                  <p style={{ margin: 0, padding: '14px 0', color: '#7D798A' }}>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── DEMO FORM ── */}
      <section id="demo" style={styles.section}>
        <div style={styles.sectionInner}>
          <div className="lp-form-split" style={styles.formSectionLayout}>
            <div style={styles.formInfo}>
              <span style={styles.sectionTag}>ابدأ الآن</span>
              <h2 style={styles.formInfoTitle}>احصل على نسخة تجريبية مجانية</h2>
              <ul style={styles.formInfoList}>
                <li style={styles.formInfoItem}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3E2C6E" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                  نظام مجهز بالكامل — جربه بدون أي التزام
                </li>
                <li style={styles.formInfoItem}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3E2C6E" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
                  تدريب مجاني لفريقك على استخدام النظام
                </li>
                <li style={styles.formInfoItem}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3E2C6E" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                  الدعم الفني متوفر طوال فترة التجربة
                </li>
              </ul>
            </div>
            <div style={styles.formCard}>
              <form onSubmit={handleSubmit} style={styles.form}>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>الاسم الكامل *</label>
                  <input style={{ ...styles.formInput, borderColor: errors.name ? '#7A1C1C' : '#D4D0E0' }}
                    value={form.name} onChange={e => handleChange('name', e.target.value)} placeholder="محمد أحمد" />
                  {errors.name && <span style={styles.formError}>{errors.name}</span>}
                </div>
                <div className="lp-form-row" style={styles.formRow}>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>الدولة *</label>
                    <select style={{ ...styles.formSelect, borderColor: errors.country ? '#7A1C1C' : '#D4D0E0' }}
                      value={form.country} onChange={e => {
                        const val = e.target.value;
                        handleChange('country', val);
                        const match = worldCountries.find(c => c.name_ar === val);
                        if (match && match.phone_code) {
                          handleChange('phone', match.phone_code);
                        }
                      }}>
                      <option value="">اختر الدولة</option>
                      {worldCountries.map(c => <option key={c.code} value={c.name_ar}>{c.name_ar}</option>)}
                    </select>
                    {errors.country && <span style={styles.formError}>{errors.country}</span>}
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>نشاطك التجاري *</label>
                    <select style={{ ...styles.formSelect, borderColor: errors.business_type ? '#7A1C1C' : '#D4D0E0' }}
                      value={form.business_type} onChange={e => handleChange('business_type', e.target.value)}>
                      <option value="">اختر النشاط</option>
                      {BUSINESS_TYPES.map(b => <option key={b} value={b}>{b}</option>)}
                    </select>
                    {errors.business_type && <span style={styles.formError}>{errors.business_type}</span>}
                  </div>
                </div>
                <div className="lp-form-row" style={styles.formRow}>
                  <div style={styles.formGroup}>
                    <PhoneInput
                      label="رقم الجوال *"
                      value={form.phone}
                      onChange={val => handleChange('phone', val)}
                      countries={worldCountries}
                      error={errors.phone}
                      placeholder="5X XXX XXXX"
                    />
                    <span style={styles.formHint}>يفضل أن يكون رقم الهاتف مرتبطاً بواتساب لتسهيل التواصل</span>
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>البريد الإلكتروني (اختياري)</label>
                    <input style={{ ...styles.formInput, borderColor: errors.email ? '#7A1C1C' : '#D4D0E0' }}
                      value={form.email} onChange={e => handleChange('email', e.target.value)} placeholder="example@domain.com" />
                    {errors.email && <span style={styles.formError}>{errors.email}</span>}
                  </div>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>عدد المناديب (سائقي التوصيل) *</label>
                  <input type="number" style={{ ...styles.formInput, borderColor: errors.rider_count ? '#7A1C1C' : '#D4D0E0' }}
                    value={form.rider_count} onChange={e => handleChange('rider_count', e.target.value)}
                    placeholder="مثال: ١٠" min="1" />
                  {errors.rider_count && <span style={styles.formError}>{errors.rider_count}</span>}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>وصف إضافي (اختياري)</label>
                  <textarea style={styles.formTextarea} value={form.description}
                    onChange={e => handleChange('description', e.target.value)}
                    placeholder="حدثنا عن نشاطك التجاري واحتياجاتك من المنصة..." rows="3" />
                </div>
                <button type="submit" style={{ ...styles.submitBtn, opacity: submitting ? 0.7 : 1 }} disabled={submitting}>
                  {submitting ? (
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" style={{ animation: 'spin 1s linear infinite' }}><circle cx="12" cy="12" r="10" opacity="0.3"/><path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"/></svg>
                      جاري الإرسال...
                    </span>
                  ) : 'اطلب نسختك التجريبية المجانية'}
                </button>
                <p style={styles.formFooter}>بياناتك آمنة ومشفرة — لن نشاركها مع أي طرف ثالث</p>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <div className="lp-footer-grid" style={styles.footerTop}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#E0A526" strokeWidth="2" strokeLinecap="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
                <span style={{ fontSize: 18, fontWeight: 700, color: '#fff' }}>فكر نوفا</span>
                <span style={{ fontSize: 12, color: '#E0A526', fontWeight: 500, backgroundColor: 'rgba(224,165,38,0.15)', padding: '2px 8px', borderRadius: 4 }}>للشحن</span>
              </div>
              <p style={styles.footerDesc}>منصة متكاملة لإدارة عمليات الشحن والتوصيل — نقدم حلولاً تقنية مبتكرة لشركات الشحن والتوصيل في العالم العربي.</p>
            </div>
            <div style={styles.footerLinks}>
              <h4 style={styles.footerLinkTitle}>روابط سريعة</h4>
              <a href="#features" style={styles.footerLink}>المميزات</a>
              <a href="#why-us" style={styles.footerLink}>لماذا فكر نوفا</a>
              <a href="#faq" style={styles.footerLink}>الأسئلة الشائعة</a>
              <a href="#demo" style={styles.footerLink}>طلب تجريبي</a>
            </div>
            <div style={styles.footerLinks}>
              <h4 style={styles.footerLinkTitle}>الدول المتاحة</h4>
              <span style={styles.footerLink}>السعودية، الإمارات، قطر، الكويت</span>
              <span style={styles.footerLink}>عمان، البحرين، مصر، الأردن</span>
              <span style={styles.footerLink}>العراق، سوريا، لبنان، ليبيا</span>
            </div>
          </div>
          <div style={styles.footerBar}>
            <p style={{ margin: 0 }}>© 2026 فكر نوفا للشحن — جميع الحقوق محفوظة</p>
          </div>
        </div>
      </footer>

      {/* ── WHATSAPP FLOATING ── */}
      <a href="https://wa.me/34695897730" target="_blank" rel="noopener noreferrer" style={styles.whatsappBtn} title="تواصل معنا عبر واتساب">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
      </a>
    </div>
  );
}

const styles = {
  wrapper: { direction: 'rtl', textAlign: 'right', backgroundColor: '#fff', fontFamily: "'Tajawal', system-ui, sans-serif", lineHeight: 1.6, color: '#221F2F' },

  // Nav
  nav: { position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, backgroundColor: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #D4D0E0' },
  navInner: { maxWidth: 1200, margin: '0 auto', padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  logo: { display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' },
  logoText: { fontSize: 22, fontWeight: 800, color: '#3E2C6E', letterSpacing: '-0.5px' },
  logoBadge: { fontSize: 11, fontWeight: 700, color: '#E0A526', backgroundColor: 'rgba(224,165,38,0.12)', padding: '2px 8px', borderRadius: 4, marginRight: 4 },
  navLinks: { display: 'flex', alignItems: 'center', gap: 28 },
  navLink: { color: '#7D798A', textDecoration: 'none', fontSize: 14, fontWeight: 500, transition: 'color 0.2s' },
  navCtaBtn: { background: 'linear-gradient(135deg, #3E2C6E 0%, rgba(62,44,110,0.9) 100%)', color: '#fff', padding: '8px 20px', borderRadius: 8, fontSize: 14, fontWeight: 600, textDecoration: 'none', transition: 'all 0.2s', boxShadow: '0 4px 12px rgba(62,44,110,0.2)' },
  mobileToggle: { display: 'none', background: 'none', border: 'none', cursor: 'pointer', color: '#3E2C6E', padding: 4 },
  mobileCtaBtn: { display: 'none', alignItems: 'center', gap: 6, padding: '8px 16px', background: 'linear-gradient(135deg,#E0A526,#D4941A)', color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: 'none', whiteSpace: 'nowrap' },
  mobileNav: { display: 'none', flexDirection: 'column', padding: '8px 24px 16px', gap: 12, borderTop: '1px solid #D4D0E0' },
  mobileNavLink: { color: '#3E2C6E', textDecoration: 'none', fontSize: 15, fontWeight: 500, padding: '6px 0' },

  // Hero
  hero: { position: 'relative', paddingTop: 80, minHeight: '100vh', display: 'flex', alignItems: 'center', overflow: 'hidden', background: 'linear-gradient(135deg, #3E2C6E 0%, #2D1F52 50%, #3E2C6E 100%)' },
  heroBg: { position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(ellipse at 20% 50%, rgba(224,165,38,0.08) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(62,44,110,0.1) 0%, transparent 50%)' },
  heroBgGlow: { position: 'absolute', top: '-30%', right: '-10%', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(224,165,38,0.06) 0%, transparent 70%)', pointerEvents: 'none' },
  heroInner: { position: 'relative', zIndex: 2, maxWidth: 900, margin: '0 auto', padding: '60px 24px', textAlign: 'center' },
  heroBadge: { display: 'inline-block', backgroundColor: 'rgba(224,165,38,0.12)', color: '#E0A526', padding: '6px 16px', borderRadius: 20, fontSize: 13, fontWeight: 600, marginBottom: 24 },
  heroTitle: { fontSize: 50, fontWeight: 800, color: '#fff', margin: '0 0 20px', lineHeight: 1.2, letterSpacing: '-0.5px' },
  heroAccent: { color: '#E0A526' },
  heroDesc: { fontSize: 17, color: '#C4BED8', margin: '0 auto 36px', maxWidth: 680, lineHeight: 1.8 },
  heroCta: { display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' },
  btnPrimary: { display: 'inline-flex', alignItems: 'center', background: 'linear-gradient(135deg, #E0A526 0%, rgba(224,165,38,0.85) 100%)', color: '#3E2C6E', padding: '14px 32px', borderRadius: 10, fontSize: 15, fontWeight: 700, textDecoration: 'none', transition: 'all 0.2s', boxShadow: '0 4px 20px rgba(224,165,38,0.35)', border: 'none', cursor: 'pointer' },
  btnOutline: { display: 'inline-flex', alignItems: 'center', backgroundColor: 'transparent', color: '#E0A526', padding: '14px 32px', borderRadius: 10, fontSize: 15, fontWeight: 600, textDecoration: 'none', border: '2px solid rgba(224,165,38,0.4)', transition: 'border-color 0.2s' },

  // Stats
  statsBar: { backgroundColor: '#2D1F52', borderTop: '1px solid rgba(255,255,255,0.05)', borderBottom: '1px solid rgba(255,255,255,0.05)' },
  statsInner: { maxWidth: 1000, margin: '0 auto', padding: '32px 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 24, flexWrap: 'wrap' },
  statItem: { textAlign: 'center' },
  statNum: { display: 'block', fontSize: 22, fontWeight: 800, color: '#E0A526', marginBottom: 4 },
  statLabel: { display: 'block', fontSize: 13, color: '#A59DB8', fontWeight: 500 },
  statDot: { width: 4, height: 4, borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.15)' },

  // Section
  section: { padding: '80px 0', backgroundColor: '#fff' },
  sectionInner: { maxWidth: 1100, margin: '0 auto', padding: '0 24px' },
  sectionHeader: { textAlign: 'center', marginBottom: 48 },
  sectionTag: { display: 'inline-block', backgroundColor: 'rgba(62,44,110,0.08)', color: '#3E2C6E', padding: '4px 14px', borderRadius: 16, fontSize: 12, fontWeight: 700, marginBottom: 12, letterSpacing: '0.3px' },
  sectionTitle: { fontSize: 34, fontWeight: 800, color: '#221F2F', margin: '0 0 12px', lineHeight: 1.2 },
  sectionSub: { fontSize: 16, color: '#7D798A', margin: 0, maxWidth: 550, marginInline: 'auto', lineHeight: 1.7 },

  // Features
  featuresGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 20 },
  featureCard: { backgroundColor: '#fff', borderRadius: 14, padding: '28px 24px', border: '1px solid #D4D0E0', transition: 'all 0.28s cubic-bezier(.34,1.55,.64,1)', position: 'relative', overflow: 'hidden' },
  featureIconWrap: { width: 48, height: 48, borderRadius: 12, backgroundColor: 'rgba(62,44,110,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 },
  featureTitle: { fontSize: 17, fontWeight: 700, color: '#221F2F', margin: '0 0 8px' },
  featureDesc: { fontSize: 14, color: '#7D798A', margin: 0, lineHeight: 1.7 },

  // Why Us
  whyGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 20, marginBottom: 48 },
  whyCard: { backgroundColor: '#fff', borderRadius: 14, padding: '24px', border: '1px solid #D4D0E0', textAlign: 'right', transition: 'all 0.28s cubic-bezier(.34,1.55,.64,1)' },
  whyIcon: { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 },
  whyTitle: { fontSize: 16, fontWeight: 700, color: '#221F2F', margin: '0 0 8px' },
  whyDesc: { fontSize: 14, color: '#7D798A', margin: 0, lineHeight: 1.7 },
  supportBanner: { background: 'linear-gradient(135deg, #3E2C6E 0%, rgba(62,44,110,0.95) 100%)', borderRadius: 16, padding: '40px 36px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' },
  supportContent: { flex: 1, minWidth: 280 },
  supportTitle: { fontSize: 20, fontWeight: 700, color: '#fff', margin: '0 0 10px' },
  supportDesc: { fontSize: 14, color: '#C4BED8', margin: 0, lineHeight: 1.7 },

  // Steps
  stepsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))', gap: 24 },
  stepCard: { position: 'relative', textAlign: 'center', padding: '24px 16px' },
  stepNum: { width: 56, height: 56, borderRadius: '50%', background: 'linear-gradient(135deg, #3E2C6E 0%, rgba(62,44,110,0.8) 100%)', color: '#fff', fontSize: 18, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' },
  stepTitle: { fontSize: 16, fontWeight: 700, color: '#221F2F', margin: '0 0 8px' },
  stepDesc: { fontSize: 14, color: '#7D798A', margin: 0, lineHeight: 1.7 },
  stepArrow: { position: 'absolute', left: -12, top: '35%', transform: 'translateY(-50%)' },

  // FAQ
  faqList: { maxWidth: 720, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 8 },
  faqItem: { backgroundColor: '#fff', borderRadius: 10, border: '1px solid #D4D0E0', overflow: 'hidden', transition: 'box-shadow 0.2s' },
  faqQuestion: { width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', fontSize: 15, fontWeight: 600, color: '#3E2C6E', textAlign: 'right', gap: 12 },
  faqAnswer: { maxHeight: 0, overflow: 'hidden', transition: 'max-height 0.25s ease, border-top-width 0.25s ease', borderTop: '1px solid #D4D0E0', borderTopWidth: 0, padding: '0 20px' },

  // Form
  formSectionLayout: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 40, alignItems: 'start' },
  formInfoTitle: { fontSize: 28, fontWeight: 800, color: '#221F2F', margin: '12px 0 24px', lineHeight: 1.3 },
  formInfoList: { listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 16 },
  formInfoItem: { display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#7D798A', lineHeight: 1.6 },
  formCard: { backgroundColor: '#fff', borderRadius: 14, padding: 32, border: '1px solid #D4D0E0', boxShadow: '0 4px 16px rgba(62,44,110,0.06)' },
  form: { display: 'flex', flexDirection: 'column', gap: 18 },
  formRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 },
  formGroup: { display: 'flex', flexDirection: 'column', gap: 5 },
  formLabel: { fontSize: 13, fontWeight: 600, color: '#3E2C6E' },
  formInput: { padding: '11px 14px', border: '1.5px solid #D4D0E0', borderRadius: 8, fontSize: 14, outline: 'none', transition: 'border-color 0.2s, box-shadow 0.2s', boxSizing: 'border-box', width: '100%', backgroundColor: '#fff', color: '#221F2F' },
  formSelect: { padding: '11px 14px', border: '1.5px solid #D4D0E0', borderRadius: 8, fontSize: 14, outline: 'none', transition: 'border-color 0.2s, box-shadow 0.2s', boxSizing: 'border-box', width: '100%', backgroundColor: '#fff', color: '#221F2F', appearance: 'none', backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%233E2C6E\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpolyline points=\'6 9 12 15 18 9\'%3E%3C/polyline%3E%3C/svg%3E")', backgroundRepeat: 'no-repeat', backgroundPosition: 'left 12px center' },
  formTextarea: { padding: '11px 14px', border: '1.5px solid #D4D0E0', borderRadius: 8, fontSize: 14, outline: 'none', transition: 'border-color 0.2s, box-shadow 0.2s', resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box', width: '100%', backgroundColor: '#fff', color: '#221F2F' },
  formHint: { fontSize: 11, color: '#A59DB8', lineHeight: 1.4 },
  formError: { fontSize: 12, color: '#7A1C1C', fontWeight: 500 },
  submitBtn: { background: 'linear-gradient(135deg, #E0A526 0%, rgba(224,165,38,0.85) 100%)', color: '#3E2C6E', border: 'none', padding: '13px 24px', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer', transition: 'all 0.2s', marginTop: 4, width: '100%', boxShadow: '0 4px 14px rgba(224,165,38,0.25)' },
  formFooter: { textAlign: 'center', fontSize: 12, color: '#A59DB8', margin: '8px 0 0' },

  // Success
  successWrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F4F1F8', padding: 24 },
  successCard: { textAlign: 'center', backgroundColor: '#fff', borderRadius: 16, padding: '60px 40px', border: '1px solid #D4D0E0', maxWidth: 480, width: '100%', boxShadow: '0 4px 24px rgba(62,44,110,0.06)' },
  successCheck: { width: 72, height: 72, borderRadius: '50%', background: 'linear-gradient(135deg, #3E2C6E 0%, rgba(62,44,110,0.9) 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' },
  successTitle: { fontSize: 24, fontWeight: 700, color: '#221F2F', margin: '0 0 12px' },
  successText: { fontSize: 15, color: '#7D798A', margin: 0, lineHeight: 1.7 },

  // Footer
  footer: { backgroundColor: '#221F2F', padding: '48px 24px 0' },
  footerInner: { maxWidth: 1100, margin: '0 auto' },
  footerTop: { display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 40, paddingBottom: 32, borderBottom: '1px solid rgba(255,255,255,0.08)' },
  footerDesc: { fontSize: 13, color: '#A59DB8', lineHeight: 1.7, maxWidth: 320, margin: 0 },
  footerLinks: { display: 'flex', flexDirection: 'column', gap: 8 },
  footerLinkTitle: { fontSize: 14, fontWeight: 700, color: '#fff', margin: '0 0 4px' },
  footerLink: { fontSize: 13, color: '#A59DB8', textDecoration: 'none' },
  footerBar: { padding: '20px 0', textAlign: 'center', fontSize: 13, color: '#6B6380' },

  // WhatsApp
  whatsappBtn: { position: 'fixed', bottom: 24, left: 24, zIndex: 999, width: 52, height: 52, borderRadius: '50%', background: 'linear-gradient(135deg,#25D366,#128C7E)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 20px rgba(37,211,102,0.35)', cursor: 'pointer', animation: 'waIn 0.5s ease-out', transition: 'transform 0.2s, box-shadow 0.2s' },
};
